export default "__VITE_ASSET__BYIclBGi__"